import { useShallow } from "zustand/shallow";
import { useUserStore } from "../../stores";

export const useRoleIds = () => {
  return useUserStore(
    useShallow((state) => ({
      roleIds: state.roleIds,
      setRoleIds: state.setRoleIds,
    }))
  );
};
